import * as React from "react";
import Routes from '../../components/Routes';
import userOfficeInfo from '../../routes/wiFiConnections'

export default () => {
  return <Routes routes={userOfficeInfo} />
}